import Mock from 'mockjs'

const MOCK030003 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'spuName': '@cword(10)',
        'categoryId': '@id',
        'categoryName': '@cword(10)',
        'brandId': '@id',
        'model': '@cword(10)',
        'goodsUnit': '元',
        'buyCondition': '500件',
        'taxRate': '0.16',
        'salesVolume|100-300': 100,
        'spuAttrBeans|2-5': [{
            'attrInfoId': '@id',
            'attrValueId': '@id'
        }],
        'attachInfos': [{
                'position': 1,
                'url': '@image("600x600",@color)',
                'context': '@cword(2,10)',
                'type': 1
            },
            {
                'position': 2,
                'url': '@image("600x600",@color)',
                'context': '@cword(2,10)',
                'type': 1
            },
            {
                'position': 3,
                'url': '@image("600x600",@color)',
                'context': '@cword(2,10)',
                'type': 1
            },
            {
                'position': 4,
                'url': '@image("600x600",@color)',
                'context': '@cword(2,10)',
                'type': 1
            },
            {
                'position': 5,
                'url': '@image("600x600",@color)',
                'context': '@cword(2,10)',
                'type': 1
            },
            {
                'url': '@image("600x600",@color)',
                'context': '@cword(2,10)',
                'type': 2
            }
        ],
        'skuInfos|2': [{
            'skuId': '@id',
            'skuName': '@cword(2,10)',
            'model': '@cword(5)',
            'priceA|100-200': 100,
            'priceB|100-200': 100,
            'priceC|100-200': 100,
            'priceD|100-200': 100,
            'attrBeans|2-5': [{
                'attrInfoId': '@id',
                'attrValueId': '@id'
            }]
        }],
        'baseData': {
            'spuAttrBase|2-5': [{
                'attrInfoId': '@id',
                'attrInfoName': '@cword(5)',
                'isNecessary|0-1': 0,
                'attrValueInfos|2-5': [{
                    'attrValueId': '@id',
                    'attrValueName': '@cname'
                }]
            }],
            'skuAttrBase|1-2': [{
                'attrInfoId': '@id',
                'attrInfoName': '@cword(5)',
                'isNecessary|0-1': 0,
                'attrValueInfos|2-5': [{
                    'attrValueId': '@id',
                    'attrValueName': '@cword(5)'
                }]
            }],
            'brandBase|2-5': [{
                'brandId': '@id',
                'brandName': '@cname'
            }]
        }
    }
});

export default MOCK030003


// WEBPACK FOOTER //
// ./src/mock/getInitProductInfo.js